/* istanbul ignore file */
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type InvitationModalProps = {
  show: boolean;
  setShowInvitationModal: (show: boolean) => void;
};

export const InvitationModal = ({
  show,
  setShowInvitationModal,
}: InvitationModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={() => setShowInvitationModal(false)}
      dialogClassName="invitations-modal__dialog"
      contentClassName="invitations-modal__content"
      className="invitations-modal"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body className="invitations-modal__body">
        <h2 className="heading-xxl">
          {t("userManagementPage.modalInvite_title")}
        </h2>
        <p className="lead">{t("userManagementPage.modalInvite_subtitle")}</p>
        <button
          className="DNA-button"
          onClick={() => setShowInvitationModal(false)}
        >
          {t("userManagementPage.ok_btn")}
        </button>
      </Modal.Body>
    </Modal>
  );
};
